export type FirestoreDate = { seconds: number; nanoseconds: number };

export const FirestoreDateToDate = (d: FirestoreDate | null) => {
  return d==null ? new Date() : new Date(d.seconds * 1000 + d.nanoseconds / 1000000);
};
